<template lang="html">
  
 <section class="intro-xs">
    <img class="w-100" src="/static/img/bkg/bkg-contacto.webp" :alt="$t('contacto.alt_images.contacto_ajusa')" width="1485" height="986">
    <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
      <div class="container-text">
        <h1 class="title title-52">{{$t('enlaces.textos.contacto')}}</h1>
      </div>
    </div>
  </section>


</template>

<script lang="js">
  export default  {
    name: 'contacto',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped>
  .contacto {

  }
</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/contacto.vue